/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import '../../styles/NewsFeedPageV2.scss';
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  getFirebase,
  isLoaded,
} from 'react-redux-firebase';
import { INewClaimReducer } from '../../reducers/reducers/typings';
// import { NewsComponentProps } from './typings';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { resetClaim } from '../../actions/new-claim';
import Helmet from 'react-helmet';
import NewsForm from '../newsFeed';
import React, { Component } from 'react';
import _ from 'lodash';

class SendNotificationPage extends Component<
  RouteComponentProps & FirebaseReducer.Reducer> {

//   componentDidMount() {
//     this.props.resetClaim();
//   }

  render() {
    const auth = (this.props as any)?.auth;
    return (
      <div className="news-feed-page-wrapper-v2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | Send News</title>
        </Helmet>
       <NewsForm
          auth={auth}
          onLogout={() => getFirebase().logout()}
        />
      </div>
    );
  }
}

const preMapStateToProps = (state: any) => {
  const {
    firebase: { profile },
  }: { firebase: FirebaseReducer.Reducer } = state;
  return {
    profile: profile,
  };
};

const mapQueryToProps = ({ profile }: { profile: any }): ReduxFirestoreQueries => {
  if (!profile.isLoaded || profile.isEmpty) {
    return [];
  }
  const queries: ReduxFirestoreQueries = [
    {
      collection: 'config',
      doc: 'claims',
      storeAs: 'claimsConfig',
    },
  ];

  if (profile.partnerId && profile.partnerId !== 'Admin') {
    queries.push({
      collection: 'partners',
      doc: profile.partnerId,
      storeAs: 'partner',
    });
  }

  return queries;
};

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
    newClaim,
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
    newClaim: INewClaimReducer;
  } = state;
  const claimsConfig = firestore.data.claimsConfig;
  const partner = firestore.data.partner;
  const profile = state.firebase.profile;
  const requiresPartner = profile?.partnerId && profile.partnerId !== 'Admin';
  const loading = !isLoaded(claimsConfig) || (requiresPartner && !isLoaded(partner));
  let claims = null;
  if (!loading) {
    const masterClaim = claimsConfig?.claims || {};
    const partnerConfig = partner?.claimTemplate?.claims || {};
    claims = _.assign({}, masterClaim, partnerConfig);
  }
  return {
    claimConfig: {
      claims: claims,
      loading: loading,
    },
    newClaim,
    auth: auth as FirebaseReducer.AuthState,
  };
};

export default compose(
  connect(preMapStateToProps),
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps, { resetClaim }),
)(SendNotificationPage);